module.exports = __webpack_public_path__ + "static/media/es.91221aeb.svg";